//@flow
import type { ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData } from '../phobos/flowTypes'

export const transformDataToEditFormData=(data:any,morpheus: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const morpheusResultsetData = data['morpheusResultset']
    formData.isInvalidDoc = morpheusResultsetData['is_invalid_doc']?morpheusResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = morpheusResultsetData['is_override_vendor_name']?morpheusResultsetData['is_override_vendor_name']:false
    
    if (morpheusResultsetData['inv_no']){
        formData.invNo = morpheusResultsetData['inv_no']
    }
    if (morpheusResultsetData['inv_date']){
        formData.invDate = morpheusResultsetData['inv_date']
    }
    if (morpheusResultsetData['po_no']){
        formData.poNo = morpheusResultsetData['po_no']
    }
    if (morpheusResultsetData['total']){
        formData.total = parseFloat(morpheusResultsetData['total'])
    }
    if (morpheusResultsetData['vendor_name']){
        formData.vendorName = morpheusResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/morpheus/editFormData.js